import { Auth } from "aws-amplify";

/**
 * APIをまとめたクラス
 */
class APIClass {
  private urlUser = process.env.REACT_APP_URL_USERS ?? "";
  private urlSensor = process.env.REACT_APP_URL_SENSORS ?? "";
  private urlPico3 = process.env.REACT_APP_URL_PICO3 ?? "";
  private urlBuildings = process.env.REACT_APP_URL_BUILDINGS ?? "";

  public async DeleteUser(userId: string) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "DELETE",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
      body: `{"UserId":"${userId}"}`,
    };
    await fetch(this.urlUser, options).then((response) => {
      if (!response.ok) {
        throw new Error("アカウント情報削除失敗");
      }
    });
  }

  /**
   * 管理用デバイスデータ(ユーザ、建物、デバイス)を取得
   */
  public async GetDeviceData() {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();

    const oUsers: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let users: any = null;
    const pUsers = fetch(this.urlUser, oUsers)
      .then((response) => {
        if (!response.ok) {
          throw new Error("ユーザー情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        users = data;
      });

    const oBuilding: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let buildings: any = null;
    const url =
      this.urlBuildings.split("/").slice(0, -1).join("/") + "/admin_buildings";
    const pBuilding = fetch(url, oBuilding)
      .then((response) => {
        if (!response.ok) {
          throw new Error("送信先情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        buildings = data;
      });

    const oPico3: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let pico3: any = null;
    const pPico3 = fetch(this.urlPico3 + "/info", oPico3)
      .then((response) => {
        if (!response.ok) {
          throw new Error("PICO3情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        pico3 = data;
      });

    const oSensors: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let sensors: any = null;
    const pSensors = fetch(this.urlSensor + "/info", oSensors)
      .then((response) => {
        if (!response.ok) {
          throw new Error("センサ情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        sensors = data;
      });

    await Promise.all([pUsers, pBuilding, pPico3, pSensors]);
    //console.log({ users, buildings, pico3, sensors })
    return { users, buildings, pico3, sensors };
  }

  /**
   * 管理用アカウントデータ(ユーザ、建物、デバイス、送信先)を取得
   */
  public async GetUserData() {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();

    const oUsers: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let users: any = null;
    const pUsers = fetch(this.urlUser, oUsers)
      .then((response) => {
        if (!response.ok) {
          throw new Error("ユーザー情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        users = data;
      });

    const oBuilding: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let buildings: any = null;
    const pBuilding = fetch(
      this.urlBuildings.split("/").slice(0, -1).join("/") + "/admin_buildings",
      oBuilding
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("建物情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        buildings = data;
      });

    const oPico3: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let pico3: any = null;
    const pPico3 = fetch(this.urlPico3 + "/info", oPico3)
      .then((response) => {
        if (!response.ok) {
          throw new Error("PICO3情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        pico3 = data;
      });

    const oSensors: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let sensors: any = null;
    const pSensors = fetch(this.urlSensor + "/info", oSensors)
      .then((response) => {
        if (!response.ok) {
          throw new Error("センサ情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        sensors = data;
      });

    await Promise.all([pUsers, pBuilding, pPico3, pSensors]);
    //console.log({ users, buildings, pico3, sensors })
    return { users, buildings, pico3, sensors };
  }

  public async GetAndonData() {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();

    const oBuilding: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let buildings: any = null;
    const pBuilding = fetch(
      this.urlBuildings.split("/").slice(0, -1).join("/") + "/admin_buildings",
      oBuilding
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("送信先情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        buildings = data;
      });

    const oPico3: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let pico3: any = null;
    const pPico3 = fetch(this.urlPico3 + "/info", oPico3)
      .then((response) => {
        if (!response.ok) {
          throw new Error("PICO3情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        pico3 = data;
      });

    const oSensors: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let sensors: any = null;
    const pSensors = fetch(this.urlSensor + "/info", oSensors)
      .then((response) => {
        if (!response.ok) {
          throw new Error("センサ情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        sensors = data;
      });
    await Promise.all([pBuilding, pPico3, pSensors]);
    // console.log({ buildings, pico3, sensors });
    return { buildings, pico3, sensors };
  }
}

const API = new APIClass();
export default API;
